import { useState, useRef, useEffect } from 'react';
import Select from 'react-select';
import './LeadsUpdatedVersion.css';
import LeadsUpdatedVersionCards from './OrderUpdatedVersionCards';
import * as XLSX from "xlsx";
import ScrollToTopButton from './ScrollToTopButton';
import EnquiryFormModal from './EnquiryFormModal'
import { useSidebar } from '../../SidebarContext';
import Sidebar from '../SideBar';
import { toast } from "react-toastify";
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import Loader from '../Loader';
import { decryptToken } from '../utils/getToken';
import OrderUpdatedVersionCards from './OrderUpdatedVersionCards';
import axios from 'axios';


const OrderUpdatedVersion = ({ fetchOrderData }) => {

    const [activeTab, setActiveTab] = useState('all');
    const [showSearchBar, setShowSearchBar] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);
    const [otherFilter, setOtherFilter] = useState('');
    const [searchCategory, setSearchCategory] = useState('');
    const [visibleCategories, setVisibleCategories] = useState(10);
    const [searchEnquiry, setSearchEnquiry] = useState('');
    const [visibleEnquiries, setVisibleEnquiries] = useState(10);
    const [showAssignSection, setShowAssignSection] = useState(false);
    const [showCheckAssignSection, setShowCheckAssignSection] = useState(false);
    const [showArchiveSection, setShowArchiveSection] = useState(false);
    const [showUploadModal, setShowUploadModal] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const [modalType, setModalType] = useState(null);
    const [selectedService, setSelectedService] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");
    const [showEnquiryModal, setShowEnquiryModal] = useState(false);
    const [leads, setLeadsData] = useState([])
    const [entriesCount, setEntriesCount] = useState(20);
    const [currentPage, setCurrentPage] = useState(1);
    const [showAssignSectionMain, setShowAssignSectionMain] = useState(false);
    const [showAssignSectionArchive, setShowAssignSectionArchive] = useState(false);
    const [selectedEmployee, setSelectedEmployee] = useState("");
    const [selectAll, setSelectAll] = useState(false);
    const [selectedLeads, setSelectedLeads] = useState([]); // Store selected lead IDs
    const [staffList, setStaffList] = useState([]); // Store staff list
    const [notesData, setNotesData] = useState([]);
    const [employeeViewFilter, setEmployeeViewFilter] = useState(null); // only for display inside showAssignSectionMain
    const [mobileSearchOpen, setMobileSearchOpen] = useState(false);
    const [showExcelModal, setShowExcelModal] = useState(false);
    const [excelUploadSuccess, setExcelUploadSuccess] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [isUploading, setIsUploading] = useState(false);
    const [uploadedFileName, setUploadedFileName] = useState("");
    const [services, setServices] = useState([]);
    const [filteredServices, setFilteredServices] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [visibleCount, setVisibleCount] = useState(10);
    const token = decryptToken("accessToken") || ""
    const [selectedDateOptions, setSelectedDateOptions] = useState([]); // ['today', 'yesterday', 'custom']
    const [customDate, setCustomDate] = useState({ from: '', to: '' });
    const [filterStarred, setFilterStarred] = useState(false);
    const [notes, setNotes] = useState('');
    const [selectedServices, setSelectedServices] = useState([]);
    const [selectedEnquiryTypes, setSelectedEnquiryTypes] = useState([]);
    const [selectedDate, setSelectedDate] = useState('');
    const [filtersApplied, setFiltersApplied] = useState(false);
    const [showFilterDrawer, setShowFilterDrawer] = useState(false);
    const [filterMode, setFilterMode] = useState('individual');
    const userData = getDecryptedUserFromCookie("gta_mainstateuser");
    const [loadingHbtreal, setLoadingHbtreal] = useState(true);
    const [skippedEnquiries, setSkippedEnquiries] = useState([]);
    const [showSkippedModal, setShowSkippedModal] = useState(false);
    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const url = process.env.REACT_APP_LINK
    const isLoggedIn = ""


    const handleOtherChange = (event) => {
        setOtherFilter(event.target.value);
    };

    // const handleDateChange = (event) => {
    //     setSelectedDateFilter(event.target.value);
    // };

    const tabs = [
        { id: 'all enquiry', label: 'All Enquiry' },
        { id: 'new', label: 'New' },
        { id: 'assigned', label: 'Assigned' },
        { id: 'unassigned', label: 'Unassigned' },
        { id: 'archive', label: 'Archive' },
        { id: 'website', label: 'Website' }
    ];

    const allCategories = [
        'Education', 'Finance', 'Healthcare', 'Real Estate', 'Technology',
        'Hospitality', 'Retail', 'Automobile', 'Travel', 'Legal',
        'Fashion', 'Food & Beverage', 'Entertainment', 'Logistics', 'Manufacturing',
        'Construction', 'Consulting', 'Marketing', 'Media', 'Telecom'
    ];

    const handleCategorySearch = (e) => setSearchCategory(e.target.value);

    const filteredCategories = allCategories
        .filter(cat => cat.toLowerCase().includes(searchCategory.toLowerCase()))
        .slice(0, visibleCategories);

    const allEnquiries = ["Pending", "Processing", "Packed", "Shipped", "Out for delivery", "Delivered", "Cancelled"]

    const handleSearchEnquiryChange = (e) => setSearchEnquiry(e.target.value);
    const handleShowMoreEnquiry = () => setVisibleEnquiries(prev => prev + 10);

    const filteredEnquiries = allEnquiries
        .filter(enq => enq.toLowerCase().includes(searchEnquiry.toLowerCase()))
        .slice(0, visibleEnquiries);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const openEnquiryModal = () => {
        setShowEnquiryModal(true);
    };

    const closeEnquiryModal = () => {
        setShowEnquiryModal(false);
        fetchLeadsData();
    };

    const toggleFilterDrawer = () => {
        setShowFilterDrawer(prevState => !prevState);
    };

    const handleCheckboxDateChange = (e) => {
        const { value, checked } = e.target;
        setSelectedDateOptions((prev) =>
            checked ? [...prev, value] : prev.filter((v) => v !== value)
        );
    };

    const handleStarredChange = (e) => setFilterStarred(e.target.checked);
    const handleWithNotesChange = (e) => setNotes(e.target.checked ? 'withNotes' : '');

    const toggleServiceSelection = (service) => {
        setSelectedServices((prev) =>
            prev.includes(service)
                ? prev.filter((s) => s !== service)
                : [...prev, service]
        );
    };

    const toggleEnquiryTypeSelection = (type) => {
        setSelectedEnquiryTypes((prev) =>
            prev.includes(type)
                ? prev.filter((t) => t !== type)
                : [...prev, type]
        );
    };

    const handleApplyFilters = () => {
        const datePriority = ['today', 'yesterday', 'custom'];
        const finalDate = datePriority.find((d) => selectedDateOptions.includes(d)) || '';
        setSelectedDate(finalDate);
        setFiltersApplied(true);
        setShowFilterDrawer(false);
        setFilterMode('combined');
    };




    const handleClearFilters = () => {
        setSelectedDateOptions([]);
        setCustomDate({ from: '', to: '' });
        setFilterStarred(false);
        setNotes('');
        setSelectedServices([]);
        setSelectedEnquiryTypes([]);
        setSelectedDate('');
        setFiltersApplied(false);
        setFilterMode('individual');
    };


    const handleExcelUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setUploadedFileName(file.name); // ✅ Set uploaded filename
        setUploadProgress(0); // ✅ Reset progress
        setExcelUploadSuccess(false); // ✅ Reset success

        const reader = new FileReader();
        reader.onload = async (event) => {
            const data = new Uint8Array(event.target.result);
            const workbook = XLSX.read(data, { type: "array" });
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            let jsonData = XLSX.utils.sheet_to_json(worksheet);

            jsonData = jsonData.map(entry => ({
                ...entry,
                user_id: isLoggedIn.user_id
            }));

            const xhr = new XMLHttpRequest();
            xhr.open("POST", `${url}/leads/upload-excel`);
            xhr.setRequestHeader("Content-Type", "application/json");
            xhr.setRequestHeader("Authorization", `Bearer ${token}`,)
            xhr.upload.onprogress = (e) => {
                if (e.lengthComputable) {
                    const percentComplete = Math.round((e.loaded / e.total) * 100);
                    setUploadProgress(percentComplete);
                } else {
                    let simulatedProgress = 0;
                    const interval = setInterval(() => {
                        simulatedProgress += 5;
                        setUploadProgress(Math.min(simulatedProgress, 99));
                        if (simulatedProgress >= 99) clearInterval(interval);
                    }, 100);
                }
            };

            xhr.onload = () => {
                if (xhr.status === 200) {
                    const response = JSON.parse(xhr.responseText);

                    setExcelUploadSuccess(true); // ✅ Show success message
                    setUploadProgress(100);       // ✅ Full bar

                    // ✅ Important: Don't immediately close modal if skippedEnquiries exist
                    if (response.skippedEnquiries && response.skippedEnquiries.length > 0) {
                        setSkippedEnquiries(response.skippedEnquiries);
                        setShowSkippedModal(true); // Show skipped data
                    } else {
                        // Only close upload modal if no skipped enquiries
                        setTimeout(() => {
                            setShowExcelModal(false);
                            setExcelUploadSuccess(false);
                        }, 2000);
                    }

                    fetchLeadsData(); // Refresh data
                } else {
                    const response = JSON.parse(xhr.responseText);
                    alert(`Upload failed: ${response.message}`);
                    setUploadProgress(0);
                }
            };

            xhr.onerror = () => {
                alert("Network error occurred during upload.");
                setUploadProgress(0);
            };

            xhr.send(JSON.stringify({ enquiries: jsonData }));
        };

        reader.readAsArrayBuffer(file);
    };

    const applyFilters = () => {
        return leads.filter((lead) => {
            if (searchTerm.trim() !== '') {
                const leadString = JSON.stringify({
                    ...lead,
                    cart_products: lead.cart_products?.map(cp => ({
                        ...cp,
                        variation_attributes: cp.variation_attributes || {}
                    })),
                    billing_address: lead.billing_address || {},
                    shipping_address: lead.shipping_address || {}
                }).toLowerCase();

                if (!leadString.includes(searchTerm.toLowerCase())) {
                    return false;
                }
            }

            if (selectedStatus && lead.orderStatus?.toLowerCase() !== selectedStatus.toLowerCase()) return false;

            // 🔸 Status filter
            // if (selectedStatus && lead.extra?.toLowerCase() !== selectedStatus.toLowerCase()) return false;
            if (notes.trim() !== "" && lead.noteCount === 0) return false;




            // 🔸 Starred filter
            const isStarred = lead.star === true || lead.star === "true" || lead.star === 1 || lead.star === "1";
            if (filterStarred && !isStarred) return false;

            // 🔸 Date filter logic
            if (selectedDate) {
                const leadDate = new Date(lead.createdAt).toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata" });

                if (selectedDate === "today") {
                    const today = new Date().toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata" });
                    if (leadDate !== today) return false;
                } else if (selectedDate === "yesterday") {
                    const yesterday = new Date();
                    yesterday.setDate(yesterday.getDate() - 1);
                    const yesterdayStr = yesterday.toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata" });
                    if (leadDate !== yesterdayStr) return false;
                } else if (selectedDate === "tomorrow") {
                    const tomorrow = new Date();
                    tomorrow.setDate(tomorrow.getDate() + 1);
                    const tomorrowStr = tomorrow.toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata" });
                    if (leadDate !== tomorrowStr) return false;
                } else if (selectedDate === "custom") {
                    if (!customDate.from || !customDate.to) return false;

                    const leadTimestamp = new Date(lead.createdAt).setHours(0, 0, 0, 0);
                    const fromTimestamp = new Date(customDate.from).setHours(0, 0, 0, 0);
                    const toTimestamp = new Date(customDate.to).setHours(0, 0, 0, 0);

                    if (leadTimestamp < fromTimestamp || leadTimestamp > toTimestamp) return false;
                }
            }

            return true;
        });
    };



    const fetchLeadsData = async () => {
        setLoadingHbtreal(true);
        try {
            const response = await fetch(`${url}/payment/adminorder-latest`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }); // Fetch leads data
            const res = await response.json();
            const parsedOrders = res.map(order => ({
                ...order,
                cart_products: typeof order.cart_products === 'string' ? JSON.parse(order.cart_products) : order.cart_products,
                shipping_address: typeof order.shipping_address === 'string' ? JSON.parse(order.shipping_address) : order.shipping_address,
                billing_address: typeof order.billing_address === 'string' ? JSON.parse(order.billing_address) : order.billing_address,
            }));
            setLeadsData(parsedOrders);
            // console.log("order page:", parsedOrders)

        } catch (error) {
            toast.error(error, {
                position: "top-center",
                autoClose: 2000, // Close toast after 3 seconds
            });

        } finally {
            setLoadingHbtreal(false);
        }
    }


    const handleEmployeeChange = (selectedOptions) => {
        setSelectedEmployees(selectedOptions || []);
    };

    const employeeOptions = staffList.map(staff => ({
        value: staff.emplyee_ID,
        label: `${staff.firstName} ${staff.lastName} (ID: ${staff.emplyee_ID})`
    }));


    // useEffect(() => {
    //     setEntriesCount(1);
    // }, [leads]);
    const applyCombinedFilters = () => {
        if (!filtersApplied) return leads;

        return leads.filter(lead => {
            // ✅ Enquiry Status (from 'extra')
            if (selectedStatus && lead.orderStatus?.toLowerCase() !== selectedStatus.toLowerCase()) return false;

            // ✅ Service filter
            // if (selectedService && lead.related_service?.toLowerCase() !== selectedService.toLowerCase()) return false;

            // ✅ Notes filter
            // if (notes.trim() !== "" && (!lead.remark || lead.remark.trim() === "")) return false;

            // ✅ Starred
            const isStarred = lead.star === true || lead.star === 'true' || lead.star === 1 || lead.star === '1';
            if (filterStarred && !isStarred) return false;
            if (notes === 'withNotes' && (!lead.noteCount || lead.noteCount === 0)) return false;
            // if (selectedServices.length && !selectedServices.includes(lead.parent_name)) return false;
            if (selectedEnquiryTypes.length && !selectedEnquiryTypes.includes(lead.orderStatus)) return false;

            if (selectedDateOptions.length > 0) {
                let match = false;

                const leadDate = new Date(lead.createdAt);
                const leadDay = leadDate.setHours(0, 0, 0, 0);

                const today = new Date();
                const todayDay = today.setHours(0, 0, 0, 0);

                const yesterday = new Date();
                yesterday.setDate(yesterday.getDate() - 1);
                const yesterdayDay = yesterday.setHours(0, 0, 0, 0);

                if (selectedDateOptions.includes("today") && leadDay === todayDay) match = true;
                if (selectedDateOptions.includes("yesterday") && leadDay === yesterdayDay) match = true;

                if (selectedDateOptions.includes("custom")) {
                    if (customDate.from && customDate.to) {
                        const fromTimestamp = new Date(customDate.from).setHours(0, 0, 0, 0);
                        const toTimestamp = new Date(customDate.to).setHours(0, 0, 0, 0);
                        if (leadDay >= fromTimestamp && leadDay <= toTimestamp) match = true;
                    }
                }


                if (selectedDateOptions.includes("custom")) {
                    if (customDate.from && customDate.to) {
                        const leadTimestamp = new Date(lead.createdAt).setHours(0, 0, 0, 0);
                        const fromTimestamp = new Date(customDate.from).setHours(0, 0, 0, 0);
                        const toTimestamp = new Date(customDate.to).setHours(0, 0, 0, 0);

                        if (leadTimestamp >= fromTimestamp && leadTimestamp <= toTimestamp) match = true;
                    }
                }

                if (!match) return false;
            }



            return true;
        });
    };





    useEffect(() => {
        fetchLeadsData();

    }, [])

    const allFilteredLeads = filterMode === "combined" ? applyCombinedFilters() : applyFilters();
    console.log(filterMode)
    // For tab-specific display
    const filteredLeads = (() => {
        switch (activeTab) {
            case "new":
                return allFilteredLeads.filter(lead => lead.mark === "New" && !lead.archive);
            case "assigned":
                return allFilteredLeads.filter(lead => lead.staff_id && lead.staff_name && !lead.archive);
            case "unassigned":
                return allFilteredLeads.filter(lead => !lead.staff_id && !lead.staff_name && !lead.archive);
            case "archive":
                return allFilteredLeads.filter(lead => lead.archive === true || lead.archive === "true");
            case "website":
                return allFilteredLeads.filter(lead => lead.dob && !lead.archive);
            case "pending":
                return allFilteredLeads.filter(lead => lead.orderStatus === "Pending" && !lead.archive)
            case "cancelled":
                return allFilteredLeads.filter(lead => lead.orderStatus === "Cancelled" && !lead.archive)
            case "delivered":
                return allFilteredLeads.filter(lead => lead.orderStatus === "Delivered" && !lead.archive)
            default:
                return allFilteredLeads.filter(lead => !lead.archive); // Exclude archived leads from the default view
        }
    })();

    useEffect(() => {
        const filtered = services.filter(service =>
            service.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredServices(filtered);
    }, [services, searchTerm]);

    const handleShowMore = () => setVisibleCount(prev => prev + 10);



    const filteredCurrentLeads = employeeViewFilter
        ? allFilteredLeads.filter((lead) => lead.staff_id === employeeViewFilter)
        : allFilteredLeads;



    // ✅ Use this for All Enquiry count display (doesn't change based on tab)
    const totalAllCount = allFilteredLeads.filter(lead => ((lead.mark === "New" || lead.mark === "Read") && !lead.archive)).length;
    const totalNewCount = allFilteredLeads.filter(lead => lead.mark === "New" && !lead.archive).length;
    const totalPendingCount = allFilteredLeads.filter(lead => lead.orderStatus === "Pending" && !lead.archive).length;
    const totalProcessingCount = allFilteredLeads.filter(lead => lead.orderStatus === "Processing" && !lead.archive).length;
    const totalPackedCount = allFilteredLeads.filter(lead => lead.orderStatus === "Packed" && !lead.archive).length;
    const totalShippedCount = allFilteredLeads.filter(lead => lead.orderStatus === "Shipped" && !lead.archive).length;
    const totalOFDCount = allFilteredLeads.filter(lead => lead.orderStatus === "Out for delivery" && !lead.archive).length;
    const totalDeliveredCount = allFilteredLeads.filter(lead => lead.orderStatus === "Delivered" && !lead.archive).length;
    const totalCancelledCount = allFilteredLeads.filter(lead => lead.orderStatus === "Cancelled" && !lead.archive).length;
    const totalAssignedCount = allFilteredLeads.filter(lead => lead.staff_id && lead.staff_name && !lead.archive).length;
    const totalUnassignedCount = allFilteredLeads.filter(lead => !lead.staff_id && !lead.staff_name && !lead.archive).length;
    const totalWebsite = allFilteredLeads.filter(lead => lead.dob && !lead.archive).length;

    const totalArchiveCount = allFilteredLeads.filter(
        (lead) => lead.archive === true || lead.archive === "true"
    ).length;



    // 🔹 Calculate total pages for filtered leads
    const totalPages = Math.ceil(filteredLeads.length / entriesCount);

    // 🔹 Get leads for the current page
    const indexOfLastLead = currentPage * entriesCount;
    const indexOfFirstLead = indexOfLastLead - entriesCount;
    const paginatedCurrentLeads = filteredLeads
        .filter((lead) => !employeeViewFilter || lead.staff_id === employeeViewFilter)
        .slice(indexOfFirstLead, indexOfLastLead);



    // 🔹 Handle page change
    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
            setSelectAll(false); // Reset "Select All" checkbox
            setSelectedLeads([]); // Clear all selected checkboxes when changing page
        }
    };

    const toggleAssignSection = () => {
        if (showAssignSection) {
            // Clear all selected checkboxes when closing
            setSelectedLeads([]);
            setSelectAll(false);
        }
        setShowAssignSection(!showAssignSection);
        setShowAssignSectionMain(false);
    };

    const toggleAssignSectionMain = () => {
        if (showAssignSectionMain) {
            setSelectedLeads([]);
            setEmployeeViewFilter("")
            setSelectAll(false);
        }
        setShowAssignSectionMain(!showAssignSectionMain);
        setShowAssignSection(false);

    };

    const toggleAssignSectionArchive = () => {
        if (showAssignSectionArchive) {
            setSelectedLeads([]);
            setEmployeeViewFilter("")
            setSelectAll(false);
        }
        setShowAssignSectionArchive(!showAssignSectionArchive);
        setShowAssignSection(false);
        setShowAssignSectionMain(false);
    };

    const [newlyAssignedLeads, setNewlyAssignedLeads] = useState([]);
    const [alreadyAssignedLeads, setAlreadyAssignedLeads] = useState([]);


    const handleSelectAll = () => {
        setSelectedLeads(prevSelected => ({
            ...prevSelected,
            [currentPage]: selectAll ? [] : paginatedCurrentLeads.map(lead => lead.id),
        }));
        setSelectAll(!selectAll);
        setNewlyAssignedLeads([]);
        setAlreadyAssignedLeads([]);
    };




    // 🔹 Handle Assign
    const handleAssign = async () => {
        if (selectedEmployees.length === 0 || Object.keys(selectedLeads).length === 0) {
            alert("Please select at least one employee and one lead.");
            return;
        }

        const extractedLeadIds = Object.values(selectedLeads).flat();

        if (extractedLeadIds.length === 0) {
            alert("No valid leads selected.");
            return;
        }

        // Build staffList payload for backend
        const staffListPayload = selectedEmployees.map(emp => ({
            staff_id: emp.value,
            staff_name: emp.label
        }));

        const payload = {
            leadIds: extractedLeadIds,
            staffList: staffListPayload
        };

        try {

            const response = await fetch(`${url}/payment/assign-order`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify(payload),
            });

            const res = await response.json();

            if (response.ok) {

                toast.success("Order Assigned Successfully!");
                fetchLeadsData();
                // ✅ Update UI with new assignments
                setLeadsData((prevLeads) =>
                    prevLeads.map((lead) => {
                        const assigned = res.newAssignments.filter(a => a.enquiry_id === lead.id);
                        if (assigned.length > 0) {
                            return {
                                ...lead,
                                assignedStaff: [
                                    ...(lead.assignedStaff || []),
                                    ...assigned.map(a => ({
                                        staff_id: a.staff_id,
                                        staff_name: a.staff_name
                                    }))
                                ]
                            };
                        }
                        return lead;
                    })
                );
            } else {
                console.error("Error assigning leads:", res);
                alert(`Error: ${res.message}`);
            }
        } catch (error) {
            console.error("Error assigning leads:", error);
            alert("An error occurred while assigning leads.");
        }
    };


    // 🔹 Handle Unassign
    const handleUnassign = async () => {
        if (Object.keys(selectedLeads).length === 0) {
            alert("Please select at least one lead to unassign.");
            return;
        }

        // Extract selected lead IDs
        const extractedLeadIds = Object.values(selectedLeads).flat();

        if (extractedLeadIds.length === 0) {
            alert("No valid leads selected.");
            return;
        }

        // Extract staff IDs from selected employees
        const staffIds = selectedEmployees.map(emp => emp.value);

        const payload = {
            leadIds: extractedLeadIds,
            staffIds: staffIds.length > 0 ? staffIds : undefined // optional
        };

        try {

            const response = await fetch(`${url}/payment/unassign-order`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(payload),
            });

            const res = await response.json();

            if (response.ok) {
                alert("Leads Unassigned Successfully!");
                fetchLeadsData(); // refresh
                setSelectedEmployees([]); // reset employees
            } else {
                console.error("Error unassigning leads:", res);
                alert(`Error: ${res.message}`);
            }
        } catch (error) {
            console.error("Error unassigning leads:", error);
            alert("An error occurred while unassigning leads.");
        }
    };


    const handleArchive = async () => {
        // Extract selected lead IDs
        const extractedLeadIds = Object.values(selectedLeads).flat();

        if (extractedLeadIds.length === 0) {
            alert("Please select at least one lead to archive.");
            return;
        }

        const payload = { inquiryIds: extractedLeadIds };

        try {
            const response = await fetch(`${url}/payment/archive-order`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(payload),
            });

            const res = await response.json();

            if (response.ok) {
                alert(`Archived ${res.archivedCount} leads successfully.`);
                // ✅ Refresh leads data
                fetchLeadsData();
                setSelectedLeads([]);
                setSelectAll(false);
                setShowAssignSectionArchive(false);
            } else {
                alert(`Failed to archive leads: ${res.message}`);
            }
        } catch (error) {
            console.error("Error archiving leads:", error);
            alert("An error occurred while archiving leads.");
        }
    };



    const SearchStaff = async () => {
        try {
            const response = await fetch(`${url}/staff`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }); // Fetch staff data
            const res = await response.json();
            setStaffList(res); // ✅ Save staff data in state
        } catch (error) {
            toast.error(error, {
                position: "top-center",
                autoClose: 2000, // Close toast after 3 seconds
            });
        }
    };

    const fetchLeadsDataNotes = async () => {
        try {
            const response = await fetch(`${url}/payment/adminorder-latest`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            const res = await response.json();
            const leadsWithNotes = await Promise.all(res.map(async (lead) => {
                const notesResponse = await fetch(`${url}/order-note/all/${lead.id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                const notesData = await notesResponse.json();
                return { ...lead, noteCount: notesData.length }; // Add `noteCount` to each lead
            }));

            setLeadsData(leadsWithNotes);

        } catch (error) {
            console.error(error);
        }
    };

    const handleUnarchive = async () => {
        const extractedLeadIds = Object.values(selectedLeads).flat();

        if (extractedLeadIds.length === 0) {
            alert("Please select at least one lead to unarchive.");
            return;
        }

        const payload = { inquiryIds: extractedLeadIds };

        try {
            const response = await fetch(`${url}/payment/unarchive-order`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(payload),
            });

            const res = await response.json();

            if (response.ok) {
                alert(`Unarchived ${res.unarchivedCount} leads successfully.`);
                fetchLeadsData();
                setSelectedLeads([]);
                setSelectAll(false);
                setShowAssignSectionArchive(false);
            } else {
                alert(`Failed to unarchive leads: ${res.message}`);
            }
        } catch (error) {
            console.error("Error unarchiving leads:", error);
            alert("An error occurred while unarchiving leads.");
        }
    };



    useEffect(() => {
        SearchStaff();
        fetchLeadsDataNotes();
    }, [])

    const toggleSection = (section) => {
        setShowAssignSection(section === 'assign' ? !showAssignSection : false);
        setShowCheckAssignSection(section === 'checkAssign' ? !showCheckAssignSection : false);
        setShowArchiveSection(section === 'archive' ? !showArchiveSection : false);
        setShowUploadModal(section === 'upload' ? !showUploadModal : false);
    };

   
    const handleDownloadExcel = async () => {
        try {
            toast.info("Preparing filtered Excel... ⏳");

            // const token = isLoggedIn?.token;
            const query = new URLSearchParams();

            // 🧩 Add date range if selected
            if (selectedDateOptions.includes("custom") && customDate.from && customDate.to) {
                query.append("from", customDate.from);
                query.append("to", customDate.to);
            } else if (selectedDateOptions.includes("today")) {
                const today = new Date().toISOString().split("T")[0];
                query.append("from", today);
                query.append("to", today);
            } else if (selectedDateOptions.includes("yesterday")) {
                const y = new Date();
                y.setDate(y.getDate() - 1);
                const yStr = y.toISOString().split("T")[0];
                query.append("from", yStr);
                query.append("to", yStr);
            }

            // 🧩 Add status filter
            if (selectedEnquiryTypes?.length) {
                query.append("status", selectedEnquiryTypes.join(","));
            }


            // 🧩 Add archive inclusion
            query.append("includeArchive", activeTab === "archive");

            const response = await axios.get(
                `${process.env.REACT_APP_LINK}/payment/orderall/export?${query.toString()}`,
                {
                    headers: { Authorization: `Bearer ${token}` },
                    responseType: "blob",
                }
            );

            const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = `Orders_${new Date().toISOString().split("T")[0]}.xlsx`;
            document.body.appendChild(link);
            link.click();
            link.remove();

            toast.success("Filtered Excel downloaded successfully ✅");
        } catch (error) {
            console.error(error);
            toast.error("Failed to download filtered Excel ❌");
        }
    };


    if (loadingHbtreal) {
        return (
            <Loader />
        );
    }


    return (
        <>
            <div className="lsuv-oms">
                <div className="lsuv-oms__header">
                    <div className="lsuv-tabs-oms">
                        <div className={`lsuv-tab-oms ${activeTab === "all" ? "lsuv-tab-oms-active" : ""}`} onClick={() => { setActiveTab("all"); setCurrentPage(1); }}>
                            All Order <span>({totalAllCount})</span>
                        </div>
                        <div className={`lsuv-tab-oms ${activeTab === "new" ? "lsuv-tab-oms-active" : ""}`} onClick={() => { setActiveTab("new"); setCurrentPage(1); }}>
                            New <span>({totalNewCount})</span>
                        </div>
                        
                        <div className={`lsuv-tab-oms ${activeTab === "pending" ? "lsuv-tab-oms-active" : ""}`} onClick={() => { setActiveTab("pending"); setCurrentPage(1); }}>
                            Pending <span>({totalPendingCount})</span>
                        </div>
                        <div className={`lsuv-tab-oms ${activeTab === "processing" ? "lsuv-tab-oms-active" : ""}`} onClick={() => { setActiveTab("pending"); setCurrentPage(1); }}>
                            Processing <span>({totalProcessingCount})</span>
                        </div>
                        <div className={`lsuv-tab-oms ${activeTab === "packed" ? "lsuv-tab-oms-active" : ""}`} onClick={() => { setActiveTab("pending"); setCurrentPage(1); }}>
                            Packed <span>({totalPackedCount})</span>
                        </div>
                        <div className={`lsuv-tab-oms ${activeTab === "shipped" ? "lsuv-tab-oms-active" : ""}`} onClick={() => { setActiveTab("pending"); setCurrentPage(1); }}>
                            Shipped <span>({totalShippedCount})</span>
                        </div>
                        <div className={`lsuv-tab-oms ${activeTab === "out for delivery" ? "lsuv-tab-oms-active" : ""}`} onClick={() => { setActiveTab("pending"); setCurrentPage(1); }}>
                            Out for <span>({totalOFDCount})</span>
                        </div>
                        <div className={`lsuv-tab-oms ${activeTab === "cancelled" ? "lsuv-tab-oms-active" : ""}`} onClick={() => { setActiveTab("cancelled"); setCurrentPage(1); }}>
                            Cancelled <span>({totalCancelledCount})</span>
                        </div>
                        <div className={`lsuv-tab-oms ${activeTab === "delivered" ? "lsuv-tab-oms-active" : ""}`} onClick={() => { setActiveTab("delivered"); setCurrentPage(1); }}>
                            Delivered <span>({totalDeliveredCount})</span>
                        </div>
                        <div className={`lsuv-tab-oms ${activeTab === "archive" ? "lsuv-tab-oms-active" : ""}`} onClick={() => { setActiveTab("archive"); setCurrentPage(1); }}>
                            Archive <span>({totalArchiveCount})</span>
                        </div>
                        {/* <div className={`lsuv-tab-oms ${activeTab === "assigned" ? "lsuv-tab-oms-active" : ""}`} onClick={() => { setActiveTab("assigned"); setCurrentPage(1); }}>
                                Assigned <span>({totalAssignedCount})</span>
                            </div>
                            <div className={`lsuv-tab-oms ${activeTab === "unassigned" ? "lsuv-tab-oms-active" : ""}`} onClick={() => { setActiveTab("unassigned"); setCurrentPage(1); }}>
                                Unassigned <span>({totalUnassignedCount})</span>
                            </div>
                            */}
                        {/* <div className={`lsuv-tab-oms ${activeTab === "website" ? "lsuv-tab-oms-active" : ""}`} onClick={() => { setActiveTab("website"); setCurrentPage(1); }}>
                                Website <span>({totalWebsite})</span>
                            </div> */}
                    </div>
                    <div className="lsuv-header-icons-oms">
                        <div className="lsuv-search-oms" onClick={() => setShowSearchBar(!showSearchBar)}>
                            <i className="fa-solid fa-magnifying-glass"></i>
                        </div>
                        <div className="lsuv-filter-oms" onClick={toggleFilterDrawer}>
                            <i className="fa-solid fa-filter"></i>
                        </div>
                        <div className="lsuv-three-dots" onClick={() => setShowDropdown(!showDropdown)} ref={dropdownRef}>
                            <i className="fa-solid fa-ellipsis-vertical"></i>
                            {showDropdown && (
                                <div className="lsuv-dropdown-menu">
                                    <div className="lsuv-dropdown-item" onClick={() => toggleSection("assign")}>
                                        Assign Order
                                    </div>
                                    <div className="lsuv-dropdown-item" onClick={() => toggleSection("checkAssign")}>
                                        Check assign
                                    </div>
                                    <div className="lsuv-dropdown-item" onClick={() => toggleSection("archive")}>
                                        Archive
                                    </div>
                                    <div className="lsuv-dropdown-item" onClick={handleDownloadExcel}>
                                        Download Excel
                                    </div>
                                    {/* <div className="lsuv-dropdown-item" onClick={() => toggleSection("upload")}>
                                            Upload excel
                                        </div>
                                        <div className="lsuv-dropdown-item" onClick={openEnquiryModal}>
                                            Add Order
                                        </div> */}
                                    <a style={{ textDecoration: "none" }} href="mailto:support@100billiontech.com" aria-label="Email Customer Support">
                                        <div className="lsuv-dropdown-item">Support</div>
                                    </a>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {showSearchBar && (
                    <div className="lsuv-searchbar-container">
                        <input
                            type="text"
                            className="lsuv-searchbar-input"
                            placeholder="Search enquiries..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                )}
                {showFilterDrawer && (
                    <div className={`lsuv-filter-drawer ${!showFilterDrawer ? 'closed' : ''}`}>
                        <div className="lsuv-filter-drawer-header">
                            <div className="lsuv-span-and-back-oms">
                                <i class="fa-solid fa-chevron-left" onClick={toggleFilterDrawer}></i>
                                <span>Filter Options</span>
                            </div>
                            <button onClick={handleClearFilters}>Clear</button>
                        </div>
                        <div className="lsuv-filter-drawer-content">
                            <div className="lsuv-filter-group-oms">
                                <p className="lsuv-filter-label">Filter by Date</p>
                                <div className="lsuv-filter-radio-group-oms">
                                    {['today', 'yesterday', 'custom'].map((value) => (
                                        <div className="lsuv-filter-radio-btn" key={value}>
                                            <input
                                                type="checkbox"
                                                id={value}
                                                name="datefilter"
                                                value={value}
                                                checked={selectedDateOptions.includes(value)}
                                                onChange={handleCheckboxDateChange}
                                            />
                                            <label htmlFor={value}>
                                                {value === 'today' && 'Today'}
                                                {value === 'yesterday' && 'Yesterday'}
                                                {value === 'custom' && 'Custom Date'}
                                            </label>
                                        </div>
                                    ))}
                                </div>

                                {selectedDateOptions.includes('custom') && (
                                    <div className="lsuv-custom-date-range">
                                        <div className="lsuv-custom-date-input-oms">
                                            <label htmlFor="fromDate">From</label>
                                            <input
                                                type="date"
                                                id="fromDate"
                                                name="fromDate"
                                                value={customDate.from}
                                                onChange={(e) => setCustomDate({ ...customDate, from: e.target.value })}
                                            />
                                        </div>

                                        <div className="lsuv-custom-date-input-oms">
                                            <label htmlFor="toDate">To</label>
                                            <input
                                                type="date"
                                                id="toDate"
                                                name="toDate"
                                                value={customDate.to}
                                                onChange={(e) => setCustomDate({ ...customDate, to: e.target.value })}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="lsuv-filter-group-oms">
                                <p className="lsuv-filter-label lsuv-others-filter-label">Filter by Others</p>
                                <div className="lsuv-filter-radio-group-oms">
                                    {/* <div className="lsuv-filter-radio-btn">
                                            <input
                                                type="checkbox"
                                                id="star"
                                                name="others"
                                                checked={filterStarred}
                                                onChange={handleStarredChange}
                                            />
                                            <label htmlFor="star">
                                                <i className="fa-solid fa-star"></i>
                                                <span>Starred</span>
                                            </label>
                                        </div> */}

                                    <div className="lsuv-filter-radio-btn">
                                        <input
                                            type="checkbox"
                                            id="note"
                                            name="others"
                                            checked={notes === 'withNotes'}
                                            onChange={handleWithNotesChange}
                                        />
                                        <label htmlFor="note">
                                            <i className="fa-solid fa-note-sticky"></i>
                                            <span>With Notes</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="lsuv-filter-group-oms">
                                    <p className="lsuv-filter-label lsuv-others-filter-label">Filter by Category</p>
                                    <input
                                        type="text"
                                        className="lsuv-category-search-input"
                                        placeholder="Search services..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                    <div className="lsuv-category-checkbox-group">
                                        {filteredServices.slice(0, visibleCount).map((service, index) => (
                                            <div className="lsuv-category-checkbox" key={index}>
                                                <input
                                                    type="checkbox"
                                                    id={`cat-${index}`}
                                                    value={service}
                                                    checked={selectedServices.includes(service)}
                                                    onChange={() => toggleServiceSelection(service)}
                                                />
                                                <label htmlFor={`cat-${index}`}>{service}</label>
                                            </div>
                                        ))}
                                    </div>
                                    {visibleCount < filteredServices.length && (
                                        <button onClick={handleShowMore} style={{ marginTop: '10px' }}>
                                            View More
                                        </button>
                                    )}
                                </div> */}



                            <div className="lsuv-filter-group-oms">
                                <p className="lsuv-filter-label lsuv-others-filter-label">Filter by  Type</p>
                                <input
                                    type="text"
                                    className="lsuv-category-search-input"
                                    placeholder="Search  type..."
                                    value={searchEnquiry}
                                    onChange={handleSearchEnquiryChange}
                                />
                                <div className="lsuv-category-checkbox-group">
                                    {filteredEnquiries.map((enquiry, index) => (
                                        <div className="lsuv-category-checkbox" key={index}>
                                            <input
                                                type="checkbox"
                                                id={`enq-${index}`}
                                                value={enquiry}
                                                checked={selectedEnquiryTypes.includes(enquiry)}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setSelectedEnquiryTypes(prev =>
                                                        prev.includes(value)
                                                            ? prev.filter(v => v !== value)
                                                            : [...prev, value]
                                                    );
                                                }}
                                            />
                                            <label htmlFor={`enq-${index}`}>{enquiry}</label>
                                        </div>
                                    ))}

                                </div>
                                {visibleEnquiries < allEnquiries.length && (
                                    <button className="lsuv-show-more-btn" onClick={handleShowMoreEnquiry}>
                                        Show More
                                    </button>
                                )}
                            </div>
                        </div>
                        <div className="lsuv-filter-drawer-footer-oms">
                            <button
                                className="lsuv-filter-drawer-close-btn"
                                onClick={handleApplyFilters}
                            >
                                Apply Filter
                            </button>
                        </div>
                    </div>
                )}

                {showAssignSection && (
                    <div className="lsuv-assign-section">
                        <div className="lsuv-assign-close-oms" onClick={() => setShowAssignSection(false)}>
                            <i className="fa-solid fa-xmark"></i>
                        </div>
                        <div className="lsuv-assign-row">
                            <div className="lsuv-assign-checkbox">
                                <input type="checkbox" id="selectAll" checked={
                                    paginatedCurrentLeads.length > 0 &&
                                    selectedLeads[currentPage]?.length === paginatedCurrentLeads.length
                                }
                                    onChange={handleSelectAll} />
                                <label htmlFor="selectAll">All</label>
                            </div>
                            <div className="lsuv-assign-select">
                                <Select
                                    options={employeeOptions}
                                    isSearchable={true}
                                    isMulti
                                    placeholder="Search Employees"
                                    onChange={handleEmployeeChange}
                                    value={selectedEmployees}
                                />
                            </div>
                        </div>
                        <div className="lsuv-assign-row-buttons">
                            <button className="lsuv-btn-assign" onClick={handleAssign}>Assign</button>
                            <button className="lsuv-btn-unassign" onClick={handleUnassign}>Unassign</button>
                        </div>
                    </div>
                )}

                {showCheckAssignSection && (
                    <div className="lsuv-assign-section">
                        <div className="lsuv-assign-close-oms" onClick={() => setShowCheckAssignSection(false)}>
                            <i className="fa-solid fa-xmark"></i>
                        </div>

                        <div className="lsuv-assign-row">
                            <div className="lsuv-assign-checkbox">
                                <input type="checkbox" id="selectAll"
                                    checked={
                                        paginatedCurrentLeads.length > 0 &&
                                        selectedLeads[currentPage]?.length === paginatedCurrentLeads.length
                                    }
                                    onChange={handleSelectAll}
                                />
                                <label htmlFor="selectAll">All</label>
                            </div>
                            <div className="lsuv-assign-select">
                                <Select
                                    options={staffList.map((staff) => ({
                                        value: staff.emplyee_ID,
                                        label: `${staff.firstName} ${staff.lastName} (ID: ${staff.emplyee_ID})`,
                                    }))}
                                    placeholder="Filter by Assigned Employee"
                                    isClearable
                                    onChange={(selectedOption) =>
                                        setEmployeeViewFilter(selectedOption ? selectedOption.value : null)
                                    }
                                    value={
                                        employeeViewFilter
                                            ? {
                                                value: employeeViewFilter,
                                                label: staffList.find((s) => s.emplyee_ID === employeeViewFilter)?.firstName +
                                                    " " +
                                                    staffList.find((s) => s.emplyee_ID === employeeViewFilter)?.lastName
                                            }
                                            : null
                                    }
                                />
                            </div>
                        </div>
                        <div className="lsuv-assign-row-buttons">
                            <button className="lsuv-btn-unassign" onClick={handleUnassign}>Unassign</button>
                        </div>
                    </div>
                )}

                {showArchiveSection && (
                    <div className="lsuv-assign-section">
                        <div className="lsuv-assign-close-oms" onClick={() => setShowArchiveSection(false)}>
                            <i className="fa-solid fa-xmark"></i>
                        </div>
                        <div className="lsuv-assign-row archive-div-oms">
                            <div className="lsuv-assign-checkbox">
                                <input type="checkbox" id="selectAll"
                                    checked={
                                        paginatedCurrentLeads.length > 0 &&
                                        selectedLeads[currentPage]?.length === paginatedCurrentLeads.length
                                    }
                                    onChange={handleSelectAll}
                                />
                                <label htmlFor="selectAll">All</label>
                            </div>
                            <div className="lsuv-assign-row-buttons">
                                <button className="lsuv-btn-assign" onClick={handleArchive}>Archive</button>
                                <button className="lsuv-btn-unassign" onClick={handleUnarchive}>Unarchive</button>
                            </div>
                        </div>
                    </div>
                )}

                {showSkippedModal && (
                    <div className="modal-overlayskipped">
                        <div className="modal-containerskipped">
                            <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Skipped Enquiries (Already Exist)</h2>
                            <div className="table-wrapper">
                                <table className="skipped-table">
                                    <thead>
                                        <tr>
                                            <th>Mobile Number</th>
                                            <th>Name</th>
                                            <th>Budget</th>
                                            <th>Address</th>
                                            <th>Remark</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {skippedEnquiries.map((entry, index) => (
                                            <tr key={index}>
                                                <td>{entry.mobile || '-'}</td>
                                                <td>{entry.name || '-'}</td>
                                                <td>{entry.budget || '-'}</td>
                                                <td>{entry.address || '-'}</td>
                                                <td>{entry.remark || '-'}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <button
                                style={{
                                    marginTop: "20px",
                                    padding: "10px 20px",
                                    background: "#4CAF50",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                    display: "block",
                                    marginLeft: "auto",
                                    marginRight: "auto"
                                }}
                                onClick={() => setShowSkippedModal(false)}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                )}



                {/* {showUploadModal && (
                        <div className="lsuv-modal-overlay">
                            <div className="lsuv-modal-content">
                                <div className="lsuv-modal-header">
                                    <h3><i className="fa-solid fa-file-excel"></i> Upload Excel</h3>
                                    <button className="lsuv-close-btn" onClick={() => setShowUploadModal(false)}>
                                        <i className="fa-solid fa-xmark"></i>
                                    </button>
                                </div>

                                <p className="lsuv-modal-subtitle">Supported formats: <strong>.xls, .xlsx</strong></p>

                                <div className="lsuv-upload-wrapper">
                                    <input
                                        type="file"
                                        id="excel-upload"
                                        accept=".xls,.xlsx"
                                        onChange={handleExcelUpload}
                                        hidden
                                    />
                                    <label htmlFor="excel-upload" className="lsuv-upload-label">
                                        <i className="fa-solid fa-upload"></i> Select Excel File
                                    </label>
                                </div>

                                {uploadedFileName && (
                                    <p className="lsuv-uploaded-file-name">
                                        <i className="fa-solid fa-file"></i> {uploadedFileName}
                                    </p>
                                )}
                                {uploadProgress > 0 && (
                                    <div className="progress-bar-container">
                                        <div className="progress-bar" style={{ width: `${uploadProgress}%` }}>
                                            {uploadProgress}%
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    )} */}
                {showUploadModal && (
                    <div className="lsuv-modal-overlay">
                        <div className="lsuv-modal-content">
                            <div className="lsuv-modal-header">
                                <h3><i className="fa-solid fa-file-excel"></i> Upload Excel</h3>
                                <button className="lsuv-close-btn" onClick={() => {
                                    setShowUploadModal(false)
                                    setUploadProgress(0)
                                    setUploadedFileName(null)
                                    setExcelUploadSuccess(null)
                                }}>
                                    <i className="fa-solid fa-xmark"></i>
                                </button>
                            </div>

                            <p className="lsuv-modal-subtitle">Supported formats: <strong>.xls, .xlsx</strong></p>

                            <div className="lsuv-upload-wrapper">
                                <input
                                    type="file"
                                    id="excel-upload"
                                    accept=".xls,.xlsx"
                                    onChange={handleExcelUpload}
                                    hidden
                                />
                                <label htmlFor="excel-upload" className="lsuv-upload-label">
                                    <i className="fa-solid fa-upload"></i> Select Excel File
                                </label>
                            </div>

                            {/* ✅ Show Uploaded File Name */}
                            {uploadedFileName && (
                                <p className="lsuv-uploaded-file-name">
                                    <i className="fa-solid fa-file"></i> {uploadedFileName}
                                </p>
                            )}

                            {/* ✅ Show Loading Progress Bar */}
                            {uploadProgress > 0 && (
                                <div className="progress-bar-container">
                                    <div className="progress-bar" style={{ width: `${uploadProgress}%` }}>
                                        {uploadProgress}%
                                    </div>
                                </div>
                            )}

                            {/* ✅ Show Excel Success Message */}
                            {excelUploadSuccess && (
                                <div style={{
                                    marginTop: "15px",
                                    padding: "10px",
                                    backgroundColor: "#d4edda",
                                    color: "#155724",
                                    border: "1px solid #c3e6cb",
                                    borderRadius: "5px",
                                    textAlign: "center",
                                    fontWeight: "bold",
                                    fontSize: "14px"
                                }}>
                                    ✅ Excel uploaded successfully!
                                </div>
                            )}
                        </div>
                    </div>
                )}

            </div>

            {!showSearchBar && paginatedCurrentLeads.length > 0 && (
                <div className="pagination-ui-wrapper">
                    <div className="pagination-ui-entries">
                        <label>Entries:</label>
                        <select
                            value={entriesCount}
                            onChange={(e) => {
                                setEntriesCount(Number(e.target.value));
                                setCurrentPage(1);
                            }}
                        >
                            <option value="20">20</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="500">500</option>
                            <option value="1000">1000</option>
                        </select>
                    </div>

                    <div className="pagination-ui-controls">
                        <button
                            className="pagination-ui-btn"
                            onClick={() => paginate(currentPage - 1)}
                            disabled={currentPage === 1}
                        >
                            <i class="fa-solid fa-chevron-left"></i>
                        </button>

                        <span className="pagination-ui-info">
                            {currentPage} of {totalPages}
                        </span>

                        <button
                            className="pagination-ui-btn"
                            onClick={() => paginate(currentPage + 1)}
                            disabled={currentPage === totalPages}
                        >
                            <i class="fa-solid fa-chevron-right"></i>
                        </button>
                    </div>
                </div>
            )}
            {paginatedCurrentLeads.length > 0 ? (
                <OrderUpdatedVersionCards
                    leads={paginatedCurrentLeads}
                    setLeads={setLeadsData}
                    selectedLeads={selectedLeads}
                    setSelectedLeads={setSelectedLeads}
                    currentPage={currentPage}
                    newlyAssignedLeads={newlyAssignedLeads}
                    setNewlyAssignedLeads={setNewlyAssignedLeads}
                    alreadyAssignedLeads={alreadyAssignedLeads}
                    setAlreadyAssignedLeads={setAlreadyAssignedLeads}
                    leadsDataMain={fetchLeadsData}
                    fetchOrderData={fetchOrderData}
                />
            ) : (
                <div className="no-leads-message" style={{ textAlign: "center", margin: "50px" }}>No order available</div>
            )}
            {!showSearchBar && paginatedCurrentLeads.length > 0 && (
                <div className='bottom-pagination-oms'>
                    <div className="pagination-ui-wrapper">
                        <div className="pagination-ui-entries">
                            <label>Entries:</label>
                            <select
                                value={entriesCount}
                                onChange={(e) => {
                                    setEntriesCount(Number(e.target.value));
                                    setCurrentPage(1);
                                }}
                            >
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                                <option value="500">500</option>
                                <option value="1000">1000</option>
                            </select>
                        </div>

                        <div className="pagination-ui-controls">
                            <button
                                className="pagination-ui-btn"
                                onClick={() => paginate(currentPage - 1)}
                                disabled={currentPage === 1}
                            >
                                <i class="fa-solid fa-chevron-left"></i>
                            </button>

                            <span className="pagination-ui-info">
                                {currentPage} of {totalPages}
                            </span>

                            <button
                                className="pagination-ui-btn"
                                onClick={() => paginate(currentPage + 1)}
                                disabled={currentPage === totalPages}
                            >
                                <i class="fa-solid fa-chevron-right"></i>
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* <EnquiryFormModal showEnquiryModal={showEnquiryModal} closeModal={closeEnquiryModal} /> */}
            <ScrollToTopButton />
        </>
    );
};

export default OrderUpdatedVersion;